import api from '../../../App/socket';

export const getBikeVariants = model_id => (
    api.send({
        api: 'module',
        module: 'PlatformManagement',
        classMethod: 'GetBikeVariantsByModelIdAndCalcData',
        options: {
            where: {
                model_id,
            },
            order: {
                year: -1,
            },
        },
    }).then(response => response.options).catch(error => error)
);



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Bike_model_update/requests/get_bike_variants_request.js